// extracted by mini-css-extract-plugin
module.exports = {"new-row":"FundDatasetNewRow_new-row__21_oI"};